import { SxProps } from '@mui/material';

export const AdminStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    minHeight: '111.11vh',
    padding: '40px 20px',
  },
  title: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    marginBottom: '40px',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    textAlign: 'center',
    textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  },
  subtitle: {
    fontSize: '1.2rem',
    color: 'text.secondary',
    marginBottom: '20px',
    textAlign: 'center',
    maxWidth: '600px',
  },
  dashboardGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '24px',
    width: '100%',
    maxWidth: '1200px',
    marginBottom: '40px',
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '20px',
    width: '100%',
    maxWidth: '1000px',
    marginBottom: '40px',
  },
  statCard: {
    background: 'rgba(255, 255, 255, 0.9)',
    backdropFilter: 'blur(10px)',
    borderRadius: '16px',
    padding: '24px',
    textAlign: 'center',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
    },
  },
  statNumber: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    color: 'primary.main',
    marginBottom: '8px',
  },
  statLabel: {
    fontSize: '0.9rem',
    color: 'text.secondary',
    fontWeight: '500',
  },
  navigationCard: {
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    borderRadius: '20px',
    padding: '32px',
    textAlign: 'center',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    '&:hover': {
      transform: 'translateY(-8px)',
      boxShadow: '0 16px 48px rgba(0, 0, 0, 0.2)',
      background: 'rgba(255, 255, 255, 1)',
    },
  },
  cardIcon: {
    fontSize: '3rem',
    marginBottom: '16px',
    color: 'primary.main',
  },
  cardTitle: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    marginBottom: '12px',
    color: 'text.primary',
  },
  cardDescription: {
    fontSize: '1rem',
    color: 'text.secondary',
    lineHeight: 1.5,
  },
  tableContainer: {
    maxWidth: '90%',
    maxHeight: '70vh',
    overflowX: 'auto',
    borderRadius: '12px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  },
  tableHeader: {
    backgroundColor: 'primary.light',
  },
  tableHeaderCell: {
    fontWeight: 'bold',
    fontSize: '1rem',
  },
  welcomeSection: {
    textAlign: 'center',
    marginBottom: '30px',
    maxWidth: '800px',
  },
  adminBadge: {
    display: 'inline-block',
    background: 'linear-gradient(45deg, #FF6B6B, #4ECDC4)',
    color: 'white',
    padding: '8px 20px',
    borderRadius: '25px',
    fontSize: '0.9rem',
    fontWeight: 'bold',
    marginBottom: '20px',
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
  },
} satisfies Record<string, SxProps>;
